import React from "react";
import classNames from "classnames";
import format from "date-fns/format";

const style = {
    padding: "1rem"
};

interface IAutoRateProps {
    dateFormat?: string;
    date?: Date;
    name: string;
    rate: number;
    className?: string;
}

export default ({ name, rate, className, date = new Date(), dateFormat = "MM/d/yyyy" }: IAutoRateProps) => {
    return (
        <div style={style} className={classNames(className)}>
            <div style={{
                background: "white",
                padding: "1rem"
            }}>
                <div className="text-primary font-weight-bold mb-1">Today&apos;s Rate - Valid {format(date, dateFormat)}</div>
                <h3 style={{ lineHeight: "1.5rem" }}>{name}</h3>
                <div>As low as</div>
                <span className="text-primary" style={{ fontSize: "56px", lineHeight: "2.5rem" }}>{rate}%</span><small className="text-primary">APR</small>
            </div>
        </div>
    );
};
